// Faithful port of eb-ui `packages/eds/eds-share-box/src/utils.js`.
//
// ⚠ Trap C (memory.md — EDS interactive-component contract): the share buttons
// are eds IconButtons with an onClick ONLY (no `type="link"`/href); navigation
// happens programmatically here via `window.open` — this `openUrl` call inside
// each handler IS the `openInNewTab`-style compensation. It must be preserved,
// or every share button silently "does nothing" (the run-2 social-icons bug).
import { HAS_WINDOW } from '../../lib/featureDetection';

export interface WindowSettings {
    name: string;
    width?: number;
    height?: number;
    noPopup?: boolean;
}

const DEFAULT_WINDOW_SETTINGS: WindowSettings = {
    name: 'popup',
    width: 550,
    height: 450,
};

const _buildWindowSettings = (width?: number, height?: number) =>
    `toolbar=yes,width=${width},height=${height}`;

export const openUrl = (
    url: string,
    settings: WindowSettings = DEFAULT_WINDOW_SETTINGS,
): void => {
    const { name, width, height } = settings;
    const usePopup = !settings.noPopup;

    if (!HAS_WINDOW) {
        return;
    }

    window.open(
        url,
        name,
        usePopup ? _buildWindowSettings(width, height) : undefined,
    );
};
